export const SET_USER = "SET_USER";
export const HTTP_USER_REQUEST = "HTTP_USER_REQUEST";
export const HTTP_USER_REQUEST_SUCCESS = "HTTP_USER_REQUEST_SUCCESS";
export const HTTP_USER_REQUEST_FAILURE = "HTTP_USER_REQUEST_FAILURE";
